<template>
    <div class="trainOnline">
       <div class="leftSection">
           <div  class="subject">
               <div class="title">专题培训</div>
                <el-collapse v-model="activeNames" style="margin-top:20px">
                    <el-collapse-item class="subTitle" :title="item.name" :name="index" v-for="(item, index) in subjectArr" :key="index">
                      <div class="subli" style="cursor:pointer;" @click="clickSubli(index,t.src,i)" v-for="(t,i) in item.children" :key="i">  {{t.name}}</div>
                    </el-collapse-item>
                </el-collapse>
           </div>
       </div>
       <div class="rightVideo">
           <!-- <iframe style="width:1200px; height:675px" src="//player.bilibili.com/player.html?aid=377383522&bvid=BV1po4y1U7be&cid=390280383&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe> -->
            <iframe :src="videoSrc" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" sandbox="allow-forms allow-scripts allow-same-origin "> </iframe>
       </div>
       
    </div>
</template>
<script>
import { getAction, postAction } from '@/request/http'//引入封装的get post方法
export default {
    components: {},
    data(){
        return{
            subjectArr:[
                {
                    name:'USB技术应用与开发',
                    children:[
                        
                        {name: '认识USB传输', src:'https://www.bilibili.com/video/BV1sy4y1n7d9/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: '连接和枚举', src:'https://www.bilibili.com/video/BV1fV411q7Bv/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: '实现USB键盘', src:'https://www.bilibili.com/video/BV1d5411J74M/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: '实现USB鼠标', src:'https://www.bilibili.com/video/BV1gK4y1p79G/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: 'USB主机操作HID设备', src:'https://www.bilibili.com/video/BV1jA411u7bz/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: '制作U盘案例', src:'https://www.bilibili.com/video/BV1eX4y1N75a/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: 'CDC串口设备案例', src:'https://www.bilibili.com/video/BV16z4y1m7EQ/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: '自定义USB设备案例', src:'https://www.bilibili.com/video/BV1Zo4y1R7dP/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: 'Android设备的USB通告-AOA协议', src:'https://www.bilibili.com/video/BV1ir4y1K7hb/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: 'USB高速主机文件方式驱动U盘', src:'https://www.bilibili.com/video/BV1kf4y167HY/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                    ]
                },
                {
                    name:'MounRiver Studio(MRS)使用',
                    children:[
                        {name: '工程新建', src:'https://www.bilibili.com/video/BV1MM4y1g7W6/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: '工程编译', src:'https://www.bilibili.com/video/BV1nV411x78P/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: '工程烧录', src:'https://www.bilibili.com/video/BV1Go4y1C7fp/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: '文件对比与替换', src:'https://www.bilibili.com/video/BV1So4y1k79o/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: '代码查看', src:'https://www.bilibili.com/video/BV13h411h7b5/?share_source=copy_web&vd_source=3e738c6ccce68e39bfe9bc37cc2fb502',},
                        {name: '编程辅助功能', src:'https://www.bilibili.com/video/BV1Go4y1C7X5/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: 'CH573开发演示', src:'https://www.bilibili.com/video/BV14w411o72x/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                        {name: 'CH32v103开发演示', src:'https://www.bilibili.com/video/BV1264y197Wx/?share_source=copy_web&vd_source=20513a75f09b12ba548bd789244a8a89',},
                    ]
                },
                {
                    name:'CH32V系列RISC-V MCU开发实战',
                    children:[
                        //<iframe src="//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=949073563&page=22" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
                        {name: 'RISC-V架构的基本介绍', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=906461468&page=1',},
                        {name: 'MCU的概述-以CH32V203为例', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=906467373&page=2',},
                        {name: 'RISC-V MCU 开发工具的使用', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=906477576&page=3',},
                        {name: 'RISC-V MCU GPIO使用', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=906547009&page=4',},
                        {name: 'GPIO端口的复用和重映射及RCC', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=906509552&page=5',},
                        {name: '录音喊话器项目简介', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=916054144&page=6',},
                        {name: '录音喊话器项目之 ADC简介', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=916053389&page=7',},
                        {name: '录音喊话器项目之 ADC单通道采集', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=916050221&page=8',},
                        {name: '录音喊话器项目之 ADC内部通道采集', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=916049284&page=9',},
                        {name: '录音喊话器项目之 ADC多通道及定时触发采集', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=916052088&page=10',},
                        {name: '录音喊话器项目之 OPA简介', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=916050920&page=11',},
                        {name: '录音喊话器项目之 OPA 放大麦克风信号', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=916059581&page=12',},
                        {name: '录音喊话器项目之 DAC简介', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=916055360&page=13',},
                        {name: '录音喊话器项目之 DAC 输出麦克风信号', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=916056812&page=14',},
                        {name: '图像采集和处理一', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=937214713&page=15',},
                        {name: '图像采集和处理二', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=937206724&page=16',},
                        {name: '图像采集和处理三', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=937189138&page=17',},
                        {name: '图像采集和处理四', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=937191274&page=18',},
                        {name: 'BLE无线遥控小车制作一', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=949044358&page=19',},
                        {name: 'BLE无线遥控小车制作二', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=949055731&page=20',},
                        {name: 'BLE无线遥控小车制作三', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=949071974&page=21',},
                        {name: 'BLE无线遥控小车制作四', src:'//player.bilibili.com/player.html?aid=520692493&bvid=BV1LM41167fZ&cid=949073563&page=22',},
                    ]
                }
            ],
            activeNames: ['0'],
            videoSrc:'',
        }
    },
    activated(){
        
    },
    mounted(){
          this.clickSubli(0,'https://www.bilibili.com/video/BV1sy4y1n7d9',0)//默认页面打开后加载第一个视频
    },
    watch:{
      
    },
    methods:{
        clickSubli(Index, src, index){
            console.log('外层索引----',Index)
            //切换视频
            this.videoSrc=src;
            //点击时添加样式
            console.log('doc获取到的数组====',document.getElementsByClassName("subli"))
            console.log('点击的索引===',index)
            for(var i=0;i<document.getElementsByClassName("subli").length;i++){
                 document.getElementsByClassName("subli")[i].style.backgroundColor="#fff";
                 document.getElementsByClassName("subli")[i].style.border='none'
            }
            if(Index==0){//USB
                document.getElementsByClassName("subli")[index].style.backgroundColor="#f0f0f0";
                document.getElementsByClassName("subli")[index].style.borderLeft='4px solid #1ea9fb'
            }
            else if(Index==1){//MR
                document.getElementsByClassName("subli")[index + this.subjectArr[0].children.length].style.backgroundColor="#f0f0f0";
                document.getElementsByClassName("subli")[index + this.subjectArr[0].children.length].style.borderLeft='4px solid #1ea9fb'
            }
            else if(Index==2){//CH32V系列
                document.getElementsByClassName("subli")[index + this.subjectArr[0].children.length + this.subjectArr[1].children.length].style.backgroundColor="#f0f0f0";
                document.getElementsByClassName("subli")[index + this.subjectArr[0].children.length + this.subjectArr[1].children.length].style.borderLeft='4px solid #1ea9fb'
            }
        }
    },
}
</script>
<style scoped>
 .trainOnline{
     display: flex;
     /* justify-content: space-between; */
     padding-bottom: 40px;
 }
 .trainOnline .leftSection{
     padding: 0px 20px;
     border-right: 1px solid #333;
 }
 .trainOnline .leftSection .subject{
     margin-bottom: 15px;
     width: 330px;
 }
 .trainOnline .leftSection .subject .title{
     font-size: 18px;
     color: #1ea9fb;
     font-family: 'Noto Sans SC';
     font-weight: 400;
 }
 .el-collapse-item /deep/ .el-collapse-item__header{
     font-size: 18px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 400;
 }
 .trainOnline .leftSection .subject .subTitle .subli{
     width: 330px;
     height: 30px;
     font-size: 14px;
     line-height: 30px;
     color: #808080;
     font-family: 'Noto Sans SC';
     font-weight: 400;
     padding-left: 30px;
     box-sizing: border-box;
     cursor: pointer;
 }
 .trainOnline .leftSection .product .title{
     font-size: 18px;
     color: #1ea9fb;
     font-family: 'Noto Sans SC';
     font-weight: 400;
 }
 
 .trainOnline .leftSection .product .proItem .proTitle{
     font-size: 18px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 400;
     margin: 10px 10px;
 }
 .trainOnline .leftSection .product .proItem .li{
     width: 280px;
     height: 30px;
     font-size: 14px;
     line-height: 30px;
     color: #808080;
     font-family: 'Noto Sans SC';
     font-weight: 400;
     padding-left: 30px;
     box-sizing: border-box;
     cursor: pointer;
 }
 .trainOnline .rightVideo{
     /* width: 1200px; */
     min-width: 1200px;
     height: 675px;
     margin-right: 40px;
     margin-left: 40px;
 }
 .trainOnline .rightVideo iframe{
     width: 1200px;
     height: 675px;
 }

  @media screen and (min-width:1280px) and (max-width:1601px){
    .trainOnline{
       display: flex;
       padding-bottom: 40px;
    }
    
    .trainOnline .leftSection .subject .subTitle .subli{
        width: 310px;
        padding-left: 12px;
    }
    .trainOnline .leftSection .product .proItem .li{
        width: 230px;
    }
    .el-collapse-item /deep/ .el-collapse-item__header{
     font-size: 15px;
    }
    .trainOnline .rightVideo{
       /* width: 1000px; */
       min-width: 1000px ;
       height: 675px;
       margin-left: 20px;
    }
    .trainOnline .rightVideo iframe{
     width: 1000px;
     height: 675px;
    }


  }
</style>